/**
 * Replaces every dash on a string with a space and capitalize each word of it.
 *
 * @param {string} str The string to capitalize
 * @return {string} x capitalized string
 */
export var capitalize = function (str) {
    return str.replace(/_/g, ' ')
        .replace(/(?: |\b)(\w)/g, function (key) {
        return key.toUpperCase();
    });
};
/**
 * Creates an actual object from a notation path.
 * e.g - "user.profile.addresses.0.street"
 *
 * @param {object} obj The initial object from where we are going to start creating the new one
 * @param {string | string[]} path notation path
 * @param {any} value value of the leaf
 * @return {object} obj the actual object created
 */
export var createObjFromPath = function (obj, path, value, field) {
    if (field === void 0) { field = 'diff'; }
    path = typeof path === 'string' ? path.split('.') : path;
    var current = obj;
    while (path.length > 1) {
        // @ts-ignore
        var head = path[0], tail = path.slice(1);
        path = tail;
        var second = tail[0], rest = tail.slice(1);
        if (Array.isArray(current)) {
            head = Number(head);
            if (typeof current[head] === 'undefined') {
                // Aca hay que ver si existen elementos hasta ese indice
                if (!current.length) {
                    for (var i = 0; i <= head; i++) {
                        current.push({});
                    }
                }
                else {
                    var flag = true;
                    for (var i = head; flag; i--) {
                        if (!current[i]) {
                            current.push({});
                        }
                        else {
                            flag = false;
                        }
                    }
                }
                // current.push({});
            }
        }
        else if (current[head] === undefined) {
            if (second && isNumeric(second)) {
                current[head] = [];
            }
            else {
                current[head] = {};
            }
        }
        current = current[head];
    }
    current[path[0]] = value;
    obj = formatArrayDifferences(obj, field);
    return obj;
};
var formatArrayDifferences = function (v, field, comesFromArray) {
    if (comesFromArray === void 0) { comesFromArray = false; }
    if (v === null) {
        if (comesFromArray)
            return ' ';
        return;
    }
    if (Array.isArray(v)) {
        v = v.map(function (el) {
            return formatArrayDifferences(el, field, true);
        });
        return v;
    }
    if (typeof v === 'string' && comesFromArray) {
        if (!v.startsWith('+ ') && !v.startsWith('- ')) {
            if (field === 'diff') {
                return "+ " + v;
            }
            else {
                return "- " + v;
            }
        }
    }
    if (typeof v === 'object') {
        Object.keys(v).forEach(function (key) {
            v[key] = formatArrayDifferences(v[key], field, false);
        });
        return v;
    }
    return v;
};
/**
 * Checks if a string is number or not.
 *  e.g
 * "100"  - true
 * "2"    - true
 * "-14"  - false
 *
 * @param {string} value The stringified number
 * @return {boolean} x true if is a number, false if not
 */
export var isNumeric = function (value) {
    return /^\d+$/.test(value);
};
//# sourceMappingURL=strings.js.map